const privacyStyle = {
  privacy_base: {
    container: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: 1920,
      height: 600,
      flexDirection: "column",
      marginBottom: "-10px",
      fontFamily: 'Gotham-Book !important',
      background: 'linear-gradient(90deg,hsla(0,0%,100%,0),hsla(0,0%,100%,.85) 5%,#e3e3e3)',
      left: -8,
      bottom: 0,
      paddingRight: 50,
      zIndex: 10
    },
    inner: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 1920,
      height: 600,
      flexDirection: 'column',
      borderRadius: '1px',
      fontSize: '22px',
      fontFamily: 'Gotham-Book',
      backgroundColor: 'rgba(0,0,0,0)',
      boxShadow: '0 0 0 0',
    },
    title: {
      width: '1700px',
      height: '80px',
      color: 'black',
      fontSize: '40px',
      fontWeight: '700',
      fontFamily: 'Gotham-Med',
    },
    textArea: {
      width: '1133px',
      height: '213px',
      fontFamily: 'Gotham-Med',
      color: 'black',
      fontSize: '20px'
    },
    horizontalListContainerClassName: 'privacy-base-hl-container',
    horizontalListInnerClassName: 'privacy-base-hl-inner',
    closePrivacy: {
      horizontalListContainerClassName: 'x-close-hl-container',
      horizontalListInnerClassName: 'x-close-hl-inner',
      focusableClassName: 'x-close',
      focusableFocusedClassName: 'x-close-focused'
    }
  },
  privacy_info: {
    container: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: 1920,
      height: 600,
      flexDirection: "column",
      marginBottom: "-10px",
      fontFamily: 'Gotham-Book !important',
      background: 'linear-gradient(90deg,hsla(0,0%,100%,0),hsla(0,0%,100%,.85) 5%,#e3e3e3)',
      position: 'absolute',
      left: -8,
      bottom: 0,
      zIndex: 10,     
      paddingRight: 50,
    },
    inner: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 1920,
      height: 600,
      flexDirection: 'column',
      borderRadius: '1px',
      fontSize: '22px',
      fontFamily: 'Gotham-Book',
      backgroundColor: 'rgba(0,0,0,0)',
      boxShadow: '0 0 0 0',
    },
    title: {
      width: '1700px',
      height: '80px',
      color: 'black',
      fontSize: '40px',
      fontWeight: '700',
      fontFamily: 'Gotham-Med',
    },
    textArea: {
      width: '1133px',
      height: '350px',
      fontFamily: 'Gotham-Book',
      color: 'black',
      fontSize: '20px'
    },
    horizontalListContainerClassName: 'privacy-info-hl-container',
    horizontalListInnerClassName: 'privacy-info-hl-inner',
    closePrivacy: {
      horizontalListContainerClassName: 'x-close-hl-container',
      horizontalListInnerClassName: 'x-close-hl-inner',
      focusableClassName: 'x-close',
      focusableFocusedClassName: 'x-close-focused'
    }
  },
  manager_preferences: {
    container: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: 1920,
      height: 700,
      flexDirection: "column",
      marginBottom: "-10px",
      fontFamily: 'Gotham-Book !important',
      background: 'linear-gradient(90deg,hsla(0,0%,100%,0),hsla(0,0%,100%,.85) 5%,#e3e3e3)',
      position: 'absolute',
      left: -8,
      bottom: 0,
      zIndex: 10,      
      paddingRight: 50,
    },
    inner: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 1920,
      height: 700,
      flexDirection: 'column',
      borderRadius: '1px',
      fontSize: '20px',
      fontFamily: 'Gotham-Book',
      backgroundColor: 'rgba(0,0,0,0)',
      boxShadow: '0 0 0 0',
    },
    title: {
      width: '1700px',
      height: '60px',
      color: 'black',
      fontSize: '40px',
      fontWeight: '700',
      fontFamily: 'Gotham-Med',
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center'
    },
    table: {
      width: '1700px',
      height: '360px',
      margin: '0px 0px',
      borderCollapse: 'collapse',
      border: '1px solid transparent',
      color: 'black'
    },
    tr: {},
    th_empty: {
      width: '80px'
    },
    th_cookie: {
      width: '450px'
    },
    th_description: {
      width: '1150px'
    },
    td: {
      border: '1px solid #CCCCCC',
      padding: '7px'
    },
    td_checkbox: {
      width: '80px',
      height: '70px'
    },
    td_cookie: {
      width: '450px',
      height: '70px'
    },
    td_description: {
      width: '1150px',
      height: '70px'
    },
    td_checkbox_className: "manager-preferences-td-checkbox",
    div_checkbox_className: "manager-preferences-checkbox",
    div_checkbox_selected_className: "manager-preferences-checkbox-selected",
    image_checkbox_selected: "./assets/checked-icon.png",
    image_checkbox_selected_className: 'manager-preferences-image-checkbox-selected',
    verticalListContainerClassName: 'manager-preferences-vl-container',
    verticalListInnerClassName: 'manager-preferences-vl-inner',
    verticalListItemClassName: 'manager-preferences-vl-item',
    verticalListItemFocusedClassName: 'manager-preferences-vl-item-focused',
    actionMessage: {
      container: {
        width: '1700px',
        height: '30px',
        marginBottom: '5px',
      },
      span: {
        color: 'black',
        fontFamily: 'Gotham-Book'
      }
    },
    horizontalListContainerClassName: 'manager-preferences-hl-container',
    horizontalListInnerClassName: 'manager-preferences-hl-inner',
  },
  textTemplate: 'dark',
  showPoweredBy: false,
  blackPowered: true,
  poweredWidth: 130,
  button: 'custom-privacy-button',
  focusedButton: 'custom-privacy-button-focused',
}

export default privacyStyle;